import React from 'react';

export default props => (
  <svg
    viewBox="0 0 12.14 24.28"
    className="inline-block fill-current"
    {...props}>
    <path d="M10.49 5.52v12.69a4.41 4.41 0 01-8.82 0V4.41c0-1.52 1.24-2.76 2.76-2.76 1.52 0 2.76 1.24 2.76 2.76V16c0 .61-.49 1.1-1.1 1.1-.61 0-1.1-.5-1.1-1.1V5.51H3.33V16c0 1.52 1.24 2.76 2.76 2.76 1.52 0 2.76-1.24 2.76-2.76V4.41a4.41 4.41 0 00-8.82 0v13.8c0 3.36 2.72 6.07 6.07 6.07s6.07-2.72 6.07-6.07V5.52h-1.66z" />
  </svg>
);
